// 极简定时UUID生成器
// 3分钟内相同UUID，超过3分钟新UUID，localStorage持久化
const getUUID = (key = 'uuid') => {
  const expire = 3 * 60 * 1000; // 3分钟
  
  try {
    const stored = localStorage.getItem(key);
    const now = Date.now();
    
    if (stored) {
      const { uuid, time } = JSON.parse(stored);
      if (uuid && time && (now - time <= expire)) {
        return uuid; // 返回老UUID
      }
    }
    
    // 生成新UUID
    const newUUID = crypto.randomUUID ? crypto.randomUUID() : 
      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    
    localStorage.setItem(key, JSON.stringify({ uuid: newUUID, time: now }));
    return newUUID; // 返回新UUID
  } catch {
    // 出错时返回临时UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }
};

// 检查是否过期
const isExpired = (key = 'uuid') => {
  try {
    const stored = localStorage.getItem(key);
    if (!stored) return true;
    
    const { time } = JSON.parse(stored);
    return !time || (Date.now() - time > 3 * 60 * 1000);
  } catch {
    return true;
  }
};

// 导出
export { getUUID, isExpired };